<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการกลุ่มบริษัทของผู้ให้บริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>การจัดกลุ่มผู้ให้บริการโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <!-- <li class="active">การจัดกลุ่มผู้ให้บริการ</li> -->
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <div class="row">
                    <div class="pull-right box_add" v-if="user_permission.add">
                      <button @click="Add_typegroup" class="btn btn-info btn_custom">
                        <i class="fa fa-plus"></i> เพิ่มกลุ่มบริษัท
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="wrapper_typegroup">
                  <data-tables-server  @query-change="loadData"
                    :data="data"
                    :total="total"
                    :page-size="5"
                    :pagination-props="{ background: true, pageSizes: [5, 10, 15] }"
                    :table-props="tableProps">
                    <el-table-column prop="type" label="ประเภทการให้บริการ"></el-table-column>
                    <el-table-column sortable prop="namebrand" label="ชื่อกลุ่มบริษัท"></el-table-column>
                    <el-table-column prop="logo" label="โลโก้กลุ่มบริษัท">
                      <template slot-scope="scope">
                        <div class="img-radius">
                          <img :src="scope.row.logo" alt />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="codecolor" label="โค้ดสีกลุ่มบริษัท">
                      <template slot-scope="scope">
                        <el-input
                          placeholder="กรุณากรอกข้อมูล"
                          v-model="scope.row.codecolor"
                          type="color"
                          disabled
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="จัดการ" align="center" width="120" fixed="right" v-if="user_permission.add || user_permission.edit || user_permission.delete">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                          <el-button
                            v-if="user_permission.edit"
                            size="mini"
                            type="primary"
                            @click="handleEdit(scope.$index, scope.row)"
                          >
                            <i class="el-icon-edit"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                          <el-button
                          v-if="user_permission.delete"
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)"
                          >
                            <i class="el-icon-delete-solid"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <el-dialog
                    title="ลบข้อมูลผู้ให้บริการ"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :before-close="handleClose"
                  >
                    <span>กรุณากดยืนยันการลบข้อมูล</span>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                      <el-button type="primary" @click="dialogVisible = false">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                  <!-- ////dialog -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      user_permission : {
        add : false,
        edit : false,
        delete : false
      },
      data:[],
       form: {providerType:'all', page: 1, pageSize: 5 },
      loading: false,
      label_position: "top",
      formOperator: {
        Connection_type: "all"
      },
      dialogVisible: false,
      type: null,
      tableProps: {
        border: true
      },
      providers: null
    };
  },
  mounted(){
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Typegroup
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  computed: {
   ...mapState({
      dataTable: store => store.Typegroup.dataTable,
      total: store => store.Typegroup.total,
    })
   },
  methods: {
    ...mapActions({
      queryAlltable: "Typegroup/queryAlltable",
      remove: "Typegroup/removeTypegroup",
      update_typegroup: "Typegroup/update_typegroup"
    }),
    loadData(queryInfo) {
      this.loading = true;
      let type = this.formOperator.Connection_type;
      this.form.page = queryInfo.page;
      this.form.pageSize = queryInfo.pageSize;
      this.form.providerType = this.formOperator.Connection_type;
      this.queryAlltable({ providerType:type, page:queryInfo.page, pageSize: queryInfo.pageSize});
      setTimeout(() => {
        this.providers = this.store_providers;
        this.data = this.dataTable;
        this.loading = false;
      }, 500);
    },
    search() {
     this.loading = true;
      let type = this.formOperator.Connection_type;
      this.queryAlltable({ providerType:type, page:this.form.page, pageSize: this.form.pageSize});
      setTimeout(() => {
        this.data = this.dataTable;
        this.loading = false;
      }, 500);
    },
    handleClose(done) {
      done();
    },
    handleDelete(index, row) {
      this.$confirm("ลบกลุ่มบริษัทของผู้ให้บริการ", "แจ้งเตือน", {
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
        .then(() => {
          this.remove(row.info.id)
        })
        .catch(() => {});
    },
    handleEdit(index, row) {
      // row.info.Connection_type = row.info.provider_type
      // row.info.preview_logo = row.logo
      this.update_typegroup(row.info.id)
      // this.$router.push({ name: "Edit_typegroup" });
    },
    Add_typegroup() {
      this.$router.push({ name: "Add_typegroup" });
    },
    submitUpload() {
      this.$refs.upload.submit();
    }
  }
};
</script>
